import Chip from "Components/atoms/chip"
import { HealthCheckResult, HealthStatus, ProjectHealthUI } from "models/project-health"

interface HealthCheckCardProps {
    check: HealthCheckResult
}

const HealthCheckCard = ({ check }: HealthCheckCardProps) => {
    const color = ProjectHealthUI.color(check.status)
    const notEvaluated = check.status === HealthStatus.NOT_EVALUATED

    return (
        <div className={`health-check-card border-${color}`}>
            <i className={`${ProjectHealthUI.icon(check.status)} text-${color}`} aria-hidden />
            <div className="body">
                <div className="title-row">
                    <strong>{check.label}</strong>
                    <Chip variant={ProjectHealthUI.chipVariant(check.status)}>{ProjectHealthUI.label(check.status)}</Chip>
                </div>
                <p className={notEvaluated ? "text-muted" : undefined}>{check.message}</p>
                <small className="muted">Rule: {check.threshold}</small>
                {check.note && <small className="muted"><i className="mdi mdi-information-outline me-1" />{check.note}</small>}
            </div>
        </div>
    )
}

export default HealthCheckCard
